<template>
  <div class="spinner-content" :class="isLoading ? 'is-loading spinner-area' : 'is-hidden'">
    <div class="spinner">
      <div class="double-bounce1" />
      <div class="double-bounce2" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.spinner-content {
  position: relative;
  min-height: 180px;
}
.spinner {
  width: 40px;
  height: 40px;

  position: absolute;
  margin: 4rem auto auto auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.double-bounce1, .double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: var(--primary);
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
}

.double-bounce1 {
  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}
.double-bounce2 {
  background-image: url(../assets/img/isotipo-creditu-large.png);
  background-size: cover;
  opacity: 1;
  -webkit-animation: sk-bounce-2 2.0s infinite ease-in-out;
  animation: sk-bounce-2 2.0s infinite ease-in-out;
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}
</style>
